import { render } from "./Terms.vue?vue&type=template&id=6f44b766"
const script = {}
script.render = render

export default script